namespace TabAurous.Retail {
    export interface ReceiptDetailsRow {
        ReceiptId?: number;
        TransId?: number;
        OrderId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: number;
        RefNo?: string;
        TaxId?: number;
        TaxName?: string;
        TaxAmount?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        BankId?: number;
        Denominations?: ReceiptDenominationDetailsRow[];
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptDetailsRow {
        export const idProperty = 'ReceiptId';
        export const localTextPrefix = 'Retail.ReceiptDetails';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            ReceiptId = "ReceiptId",
            TransId = "TransId",
            OrderId = "OrderId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            RefNo = "RefNo",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxAmount = "TaxAmount",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            BankId = "BankId",
            Denominations = "Denominations",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
